import '../polyfills';
import '../../styles/styles.css';
import React from 'react';
import { syncHistoryWithStore } from 'react-router-redux';
import { AppContainer } from 'react-hot-loader';
import { render } from 'react-dom';
import Loading from 'react-simple-loading';

import ConfigurationService from 'services/ConfigurationService';
import CookieStorageService from 'services/CookieStorageService';
import { HOUR_AS_MILLISECONDS } from 'enum/timeFormat';
import { initRum } from 'rum';

import errorImg from '../../images/errorImg.jpeg';

import history from './history';
import styles from './App.css';


if (window) {
  window['__webpack_public_path__'] = '';
}

const rootEl = document.getElementById('app');

render(
  <AppContainer>
    <Loading />
  </AppContainer>,
  rootEl
);

(async() => {
  try {
    await ConfigurationService.init();

    initRum();

    if (document.referrer.includes('google') && !CookieStorageService.get('dontShowPopAds')) {
      const expires = new Date(new Date().getTime() + HOUR_AS_MILLISECONDS);
      CookieStorageService.set('dontShowPopAds', true, { path: '/', expires });
    }

    const setDontShowAdsCookie = (new URL(document.location)).searchParams.get('noAds') === 'true';
    if (setDontShowAdsCookie && !CookieStorageService.get('cam4-HideAds')) {
      const expires = new Date(new Date().getTime() + HOUR_AS_MILLISECONDS);
      CookieStorageService.set('cam4-HideAds', true, { path: '/', expires });
    }

    const { init, getStore } = require('./store/configureStore');

    init();
    const store = getStore();
    syncHistoryWithStore(history, store);

    const Root = require('./Root').default;

    render(
      <AppContainer>
        <Root history={history} store={store} />
      </AppContainer>,
      rootEl
    );

    if (module.hot) {
      module.hot.accept('./Root', () => {
        const NextApp = require('./Root').default;

        render(
          <AppContainer>
            <NextApp history={history} store={store} />
          </AppContainer>,
          rootEl
        );
      });
    }
  } catch (error) {
    document.body.style = 'background: white;';
    // eslint-disable-next-line no-console -- This is exceptional situation, so we need to see some information
    console.error('App rendering error! 🚧', error);

    render(
      <AppContainer>
        <div className={styles.imgContainer}>
          <img
            alt="error"
            className={styles.errorImg}
            src={errorImg}
          />
        </div>
      </AppContainer>,
      rootEl
    );
  }
})();
